/*
 * @Description: 秒杀多店门店列表
 * @Author: kayvor
 * @Date: 2020-04-01 18:28:16
 * @LastEditTime: 2020-10-20 14:37:59
 * @LastEditors: kayvor
 */
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import {
    getDistributioStroreList
} from '@/models/storeList'
import {
    postBindDistributorCode
} from '@/models/confirmOrder'
import infiniteLoadData from '@/components/infiniteLoadData/infiniteLoadData.vue'
import distributionSearch from './distributionSearch/distributionSearch'
import {
    getLocalConfig,
    setLocalConfig
} from '@/utils/session'
export default {
    name: viewName.seckillStoreList,
    components: {
        infiniteLoadData,
        distributionSearch
    },
    data () {
        return {
            clientHeight: 0,
            currentSelected: '',
            count: 0,
            nearbySstoresList: [],
            isload: true,
            param: {
                sstore_name: '',
                b2b_spec_id: '',
                spu_id: '',
                latitude: '',
                longitude: '',
                page: 0,
                pagesize: 20,
                sstore_id: '',
                distribution_store_type: ''
            }
        }
    },
    computed: {
        ...mapState({

        }),
    },
    created () {

    },
    activated () {

    },
    mounted () {
        const { spec_id, spu_id, latitude, longitude, sstore_id, distribution_store_type } = this.$route.query
        this.$emit('setHeader', {
            title: '选择门店',
            showHeader: true,
            showLeft: true,
            hasSearch: false
        })
        this.setAppClass({
            isAppend: false,
            className: 'bgGreyColor'
        })
        Object.assign(this.param, {
            b2b_spec_id: spec_id,
            spu_id,
            latitude,
            longitude,
            distribution_store_type,
            sstore_id
        })
    },
    methods: {
        ...mapActions([
            'getNearbySstores',
            'setAppClass'
        ]),
        initParams () {
            Object.assign(this.param, {
                sstore_name: '',
                page: 0,
                pagesize: 20,
            })
            this.nearbySstoresList = []
        },
        onSearch (name) {
            this.initParams()
            Object.assign(this.param, {
                sstore_name: name
            })
            this.getPageList()
        },
        // 获取门店-分页
        getPageList () {
            if (this.nearbySstoresList.length <= this.count) {
                this.param.page++
                this.isload = true
                this.getData(this.param)
            } else {
                //  到底部了。
                // this.getData(param)
                this.isload = false
            }
        },
        getData () {
            let { distribution_code } = this.$route.query
            getDistributioStroreList(Object.assign(this.param, {
                distribution_code
            })).then(res => {
                const { data, count } = res
                this.count = count
                this.nearbySstoresList = this.nearbySstoresList.concat(data)
                this.$nextTick(() => {
                    this.clientHeight = Number(document.querySelector('.searchBox').clientHeight) + Number(document.querySelector('.store-list-count').clientHeight)
                })
                // 返回数据 < 最大条目数
                if (data.length < this.param.pagesize) {
                    this.isload = false
                } else {
                    this.isload = true
                }
            }).catch(_ => {
                this.isload = false
            })
        },
        changeSelected (id) {
            if (id === this.currentSelected) {
                this.currentSelected = ''
            } else {
                this.currentSelected = id
            }
        },
        /**
         * 上拉加载数据，在这里进行操作
         */
        scrollToEnd (scroll) {
            this.isload && this.getPageList()
        },
        /**
         * 监听是否初始化成功
         */
        init (scroll) {
            this.scroll = scroll
            this.getPageList()
        },
        /**
         * 跳转单店秒杀
        */
        goSeckill (sstore_id) {
            this.$router.push({
                path: '/seckill',
                query: {
                    sstore_id,
                    activity_id: this.$route.query.activity_id
                }
            })
        },
        selectedStore (item) {
            let { spec_id, spu_id, distribution_code, action } = this.$route.query
            if (item) {
                // 立即购买直接跳转去确认订单页面
                if (action === 'buy') {
                    this.currentSelected = item.id
                    const order = getLocalConfig('CONFIRM_ORDER') || {}
                    // 需要从选择门店直接跳转-确认订单所以数据需要重置
                    order.sstore_id = item.id
                    order.goods[0].goods_id = item.goods_id
                    setLocalConfig('CONFIRM_ORDER', order)
                    this.postBindDistributionCode(distribution_code, item.id)
                    this.$router.replace(`/confirmOrder?distribution_code=${distribution_code}`)
                } else {
                    this.$router.replace(`/distributionDetail?sstore_id=${item.id}&spec_id=${spec_id}&spu_id=${spu_id}&distribution_code=${distribution_code}`)
                }
            }
        },
        postBindDistributionCode (code, store_id) {
            if (code) {
                postBindDistributorCode({
                    distribution_code: code || '',
                    sstore_id: store_id || ''
                })
            }
        },
    },
}
